import {
  GoogleLogin,
  TokenResponse,
  googleLogout,
  useGoogleLogin,
} from "@react-oauth/google";
import "./registration-confirmation.scss";
import { useEffect, useState } from "react";
import axios from "axios";
import Form from "react-bootstrap/Form";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../hooks/typed-hooks";
import { userRegistrationSelector } from "../../../redux/reducers/user-registration/userRegistrationSlice";
import { createNewUserSession, userSessionStateSelector } from "../../../redux/reducers/user-session/userSessionSlice";

const RegistrationConfirmation: React.FC = () => {

  //navigation
  const navigate = useNavigate();
  
  //store
  const selectUserInfo = useAppSelector(userRegistrationSelector);
  const selectUserSessionInfo = useAppSelector(userSessionStateSelector);
  const dispatch = useAppDispatch();

  type UserType = Omit<
    TokenResponse,
    "error" | "error_description" | "error_uri"
  >;
  const [user, setUser] = useState<UserType | null>(null);
  const [profile, setProfile] = useState<any>([]);

  const responseMessage = (response: any) => {
    console.log("Response data : ", response);
  };
  const errorMessage = () => {
    console.log("Error");
  };

  const googleLogin = useGoogleLogin({
    onSuccess: (codeResponse) => {
      setUser(codeResponse);
      
      sessionStorage.setItem("access_token", codeResponse.access_token);
      dispatch(
        createNewUserSession({
          ...selectUserSessionInfo,
          accessToken: codeResponse.access_token
        })
      );

    },
    onError: (error) => console.log("loging failed : ", error),
  });

  useEffect(()=>{

    // Simulate verfication link click from user's mail box
    /*setTimeout(()=>{

      navigate("/registration-verification");

    }, 5000);
    */
   
  }, []);

  useEffect(() => {
    if (user) {
      axios
        .get(
          `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${user.access_token}`,
          {
            headers: {
              Authorization: `Bearer ${user.access_token}`,
              Accept: "application/json",
            },
          }
        )
        .then((res) => {
          setProfile(res.data);
          /*email: "trowelagent@gmail.com"
family_name: "ai"
given_name: "Trowel"
id: "101750992935389276550"
name: "Trowel ai"
picture: "https://lh3.googleusercontent.com/a/ACg8ocK0WGiMTnX-TV3Fu5r6VIo-erHptBFlhvlVH7vXNpxKQMco6w=s96-c"
verified_email: true */
        })
        .catch((err) => console.log(err));
    }
  }, [user]);

  const logOut = () => {
    googleLogout();
    setProfile(null);
  };

  return (
    
    <Container>
      <section className="registration-confirmation-wrapper">
        <div className="linear-gradient-circle"></div>
        <div className="linear-gradient-circle botton-gradient"></div>

        <div className="registration-confirmation-overlay">

          <div className="trowel-logo">
            {/* <span className="trwl-logo__icon"></span> */}
            {/* <span className="trwl-logo__text">TROWEL.AI</span> */}
          </div>

          <div className="email-send-info">
            <div className="email-send-info__image"></div>
            <div className="email-send-info__main-text">
              An email notification sent to Trowel admin for approval.<br/> After approval
              you will receive a verification email to activate your account.
            </div>
            <div className="email-send-info__sub-text">
              Check your inbox and verify.
            </div>

            <div className="email-send-info__resend-notification">
              <span>Send notification again</span>
            </div>
          </div>

        </div>
      </section>
    </Container>
  );
};

export default RegistrationConfirmation;
